import axios from "axios";
import { getAPIRoot } from "../../../utils/GeneralUtils";
import APIRoutes from "../../APIRoutes";

/**
 * postUpdateFeaturedFacilities
 *
 * Setting the pickup profile displayed on the TOP page.
 *
 * @param auth_token The user's auth token, used for fetching data that requires certain privileges.
 * @param ids Selected facility ids.
 * @param sentence sentence
 * @returns success or not.
 */

export const postUpdateFeaturedFacilities = async (
  auth_token: string,
  ids: Array<string>,
  sentence?: string
) => {
  try {
    const res = await axios.post(
      getAPIRoot(APIRoutes.post.admin.featured_facility, "admin"),
      {
        sonic_ids: ids,
        sonic_sentence: sentence,
      },
      {
        headers: {
          "X-Sonic-Auth": auth_token,
        },
      }
    );
    if (res.data.result === true) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
};
